var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.model.parts),function(subComponent,series_name){return _c('div',{staticClass:"box"},[_c('VisualComponent',{attrs:{"model":Object.assign({}, subComponent,{series_name: series_name})}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }